import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getFocusableElements } from './accessibilityUtils';

const TrapFocus = ({ enabled, children }) => {
  const trapRef = useRef(null);
  useEffect(() => {
    if (!enabled || !trapRef.current || !trapRef.current.firstChild) {
      return undefined;
    }

    const focusable = getFocusableElements(trapRef.current.firstChild);
    if (focusable.length === 0) {
      return undefined;
    }

    const firstFocusable = focusable[0]; // eslint-disable-line
    const lastFocusable = focusable[focusable.length - 1];
    let currentFocus = firstFocusable;
    let scrollY = null;
    let handlingFocus = false;

    const onTrapFocus = e => {
      if (handlingFocus || !trapRef.current) {
        return;
      }

      const elInsideFocusableParent = trapRef.current.firstChild.contains(e.target);
      if (!elInsideFocusableParent) {
        handlingFocus = true;
        if (currentFocus === lastFocusable) {
          firstFocusable.focus();
        } else {
          lastFocusable.focus();
        }
        handlingFocus = false;
      } else {
        currentFocus = e.target;
        if (!scrollY) {
          scrollY = window.scrollY; // eslint-disable-line
        }
      }

      if (scrollY) {
        window.scrollTo(window.scrollX, scrollY);
      }
    };

    document.addEventListener('focus', onTrapFocus, true);

    return function cleanup() {
      document.removeEventListener('focus', onTrapFocus, true);
    };
  }, [enabled]);

  return <div ref={trapRef}>{children}</div>;
};

TrapFocus.propTypes = {
  children: PropTypes.node.isRequired,
  enabled: PropTypes.bool.isRequired,
};

export default TrapFocus;
